<template>
  <div class="comment-form">
    <article class="message is-success" v-if="showThanks">
      <div class="message-header">
        <p>Thank you!</p>
        <button class="delete" aria-label="delete" v-on:click="hideThanks()"></button>
      </div>
      <div class="message-body">Your comment was successfully submitted!</div>
    </article>
    <div class="field">
      <label class="label">Submit a Comment</label>
      <div class="control">
        <textarea class="textarea" placeholder="Comment" v-model="comment"></textarea>
      </div>
    </div>
    <div class="control">
      <button class="button is-link" :disabled="comment==null || comment==''" v-on:click="submit()">Submit</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "CommentForm",
  data() {
    return {
      comment: null,
      showThanks: false
    };
  },
  props: ["moduleId"],
  methods: {
    submit: function() {
      const body = { comment: this.comment, moduleId: this.moduleId };
      const config=this.$store.getters.config;
      const url = `${process.env.VUE_APP_API_URL}comment`;
      axios.post(url, body, config).then(response => {
        if (response) {
          this.comment=null;
          this.showThanks = true;
          this.$emit('newComment')
        }
        this.logAction("submit_comment",body)
      });
    },
    hideThanks: function() {
      this.showThanks = false;
    },
    logAction: async function(action, note) {
      const body = {
        action,
        note:JSON.stringify(note)
      };
      const config = this.$store.getters.config;
      await axios.post(`${process.env.VUE_APP_API_URL}log`, body, config);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>